// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { NextPaymentPlanActionDTO } from './next-payment-plan-action-dto';
import { OrderCustomerDTO } from './order-customer-dto';
import { PaymentPlanActionDTO } from './payment-plan-action-dto';
import { PaymentPlanInstalmentDTO } from './payment-plan-instalment-dto';

/**
 * 
 * @export
 * @interface PaymentPlanDTO
 */
export interface PaymentPlanDTO {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    frequency: PaymentPlanDTOFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    status: PaymentPlanDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlanDTO
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    orderCustomerId: string;
    /**
     * 
     * @type {OrderCustomerDTO}
     * @memberof PaymentPlanDTO
     */
    orderCustomer: OrderCustomerDTO;
    /**
     * 
     * @type {Array<PaymentPlanInstalmentDTO>}
     * @memberof PaymentPlanDTO
     */
    instalments?: Array<PaymentPlanInstalmentDTO>;
    /**
     * 
     * @type {Array<PaymentPlanActionDTO>}
     * @memberof PaymentPlanDTO
     */
    actions?: Array<PaymentPlanActionDTO>;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    updatedAt: string;
    /**
     * 
     * @type {NextPaymentPlanActionDTO}
     * @memberof PaymentPlanDTO
     */
    nextAction?: NextPaymentPlanActionDTO;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    activationDeadline: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentPlanDTO
     */
    isHistoric: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlanDTO
     */
    interestAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    deferralsDisabledAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanDTO
     */
    productType?: PaymentPlanDTOProductTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentPlanDTOFrequencyEnum {
    MONTHLY = 'MONTHLY'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentPlanDTOStatusEnum {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
    DEFAULT = 'DEFAULT',
    COMPLETE = 'COMPLETE',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentPlanDTOProductTypeEnum {
    CUSTOM = 'CUSTOM',
    PAYIN3 = 'PAY_IN_3',
    PAYLATER = 'PAY_LATER'
}



